import script from "./CustomerDistributionDrag.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDistributionDrag.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDistributionDrag.vue?vue&type=style&index=0&id=20187190&lang=scss"

const __exports__ = script;

export default __exports__